import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"

export const startProjectBridgeGeneration = api(async function startProjectBridgeGeneration({ importId }) {
    if (!importId) return null

    return mutate(
        gql`
            mutation StartProjectBridgeGeneration($importId: ID!) {
                startProjectBridgeGeneration(importId: $importId)
            }
        `,
        { importId },
        { returns: "startProjectBridgeGeneration" }
    )
})
